module.exports = __webpack_public_path__ + "static/media/ic_sp_vertical_active.a4d0f1c9.svg";